// export const api = {
//   SERVICE: {
//     // 该接口用于新增摄像机组信息
//     addBayonet: '/cms/bayonetManage/addBayonet.json',
//     // 删除卡口信息
//     deletebayonet: '/cms/bayonetManage/deletebayonet.json',
//     // 3更新卡口信息
//     updatebayonet: '/cms/bayonetManage/updatebayonet.json',
//     // 该接口用于查询卡口信息
//     querybayonet: '/cms/bayonetManage/querybayonet.json',
//     // 查询卡口详情
//     querybayonetinfo: '/cms/bayonetManage/querybayonetinfo.json'
//   }
// }

export const api = {
  SERVICE: {
    // 该接口用于新增摄像机组信息
    addBayonet: '/vas/bayonet/addBayonet.json',
    // 删除卡口信息
    deletebayonet: '/vas/bayonet/deletebayonet.json',
    // 3更新卡口信息
    updatebayonet: '/vas/bayonet/updatebayonet.json',
    // 该接口用于查询卡口信息
    querybayonet: '/vas/bayonet/querybayonet.json',
    // 查询卡口详情
    querybayonetinfo: '/vas/bayonet/querybayonetinfo.json'
  }
}
